
import {
  defineComponent,
  toRefs,
  reactive
} from 'vue'
import CPagination from "@/components/pagination/Index.vue"
import CustomTab from '../../components/CustomTab.vue'
import { getOrgList } from '@/apis/northboundFunds'
import { useRoute } from "vue-router";
export default defineComponent({
  components: {
    CPagination,
    CustomTab
  },
  setup(props, context) {
    const route = useRoute();
    const dataMap = reactive({
      loading: false,
      timeSelected: {},
      stockList: [
      
      ],
    })

    let params = { 
      stockCode: route.query.code,//'000913.SZ',
      timeUnit: '',
      orderBy: 'date',
      order: 'DESC',
      pageNum: '1',
      pageSize: '10'
    }

    const fetchData = async (value:any) => {
      if( value.value ){
        dataMap.timeSelected = value
        params['timeUnit'] = value.value
        if( value.count !== 'DAYS' ){
          delete params['count']
        }
      }
      if( value.pageNum ){
        params['pageNum'] = value.pageNum
      }
      if( value.pageSize ){
        params['pageSize'] = value.pageSize
      }
      if( value.count ){
        params['count'] = value.count
      }
      

      dataMap.loading = true
      const list = await getOrgList(params)
      if( list ){
        dataMap.stockList = (list as any).data;
      }
      dataMap.loading = false
    }

    const sortChange = (column: any) => {
      let isAsc = column.order === "ascending" ? 'ASC' : 'DESC';
      params['orderBy'] = column["prop"]
      params['order'] = isAsc
      fetchData({})
    };

    const addClass = (column:any) => { 
      if( column.column.property === params.orderBy ){
        return 'sort-bg'
      }
    }
    
    return {
      ...toRefs(dataMap),
      fetchData,
      sortChange,
      addClass
    }
  }
})
